import React, { useState, useEffect } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import 'react-material-symbols/rounded';
import AxiosClient from '../../assets/AxiosClient';
import CitiesInIraq from "../../Forms/Data/CitiesInIraq"
import Countries from '../../Forms/Data/Countries';
import { DataTable, PageHeader } from '../../componants/Workspace';
const standardizeCity = (country, city) => {
  if (country === "Iraq") {
    return city;
  } else {
    const countryObj = Countries.find(c => c.name === country);
    if (countryObj) {
      return countryObj.Capital;
    } else {
      return null; // Country not found in the Countries array
    }
  }
};

const Cities = () => {
  const [Attendants, setAttendants] = useState([]);
  const [updatedIndexes, setUpdatedIndexes] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (Attendants.length === 0) {
      GetAttend();
    }
  }, []);

  const GetAttend = () => {
    AxiosClient.get('ETL/Attends').then((response) => {
      setAttendants(response.data);
    });
  };

  const Transfair = () => {
    const updatedAttendants = Attendants.map(attendant => {
      return {
        ...attendant,
        city: standardizeCity(attendant.country, attendant.city)
      };
    });
    setAttendants(updatedAttendants);
  };

  const Load = () => {
    const updatedIndexes = [];
    Attendants.forEach((attendant, index) => {
      AxiosClient.put(`ETL/CityUpdate/${attendant.id}`, {
        city: attendant.city // Pass the new city value in the request body
      }).then(response => {
        updatedIndexes.push(index);
        setUpdatedIndexes(updatedIndexes);
        const newProgress = ((updatedIndexes.length / Attendants.length) * 100).toFixed(2);
        setProgress(newProgress);
        // Handle success
        console.log(`City updated successfully for attendant ${attendant.id}`);
      }).catch(error => {
        console.error('Error updating attendee:', error);
      });
    });
  };

  const ShowNames = () => {
    // Implement the logic to show the names
    // You can access the names in the `Attendants` state
    // and display them in the table
  };

  return (
    <>
      <PageHeader
        title="City normalization"
        description="Standardize attendee city records before loading updates."
        actions={(
          Attendants.length === 0 ? (
            <button className="btn btn-primary" onClick={GetAttend} type="button">
              <MaterialSymbol icon="database" size={18} />
              Extract records
            </button>
          ) : (
            <>
              <button className="btn btn-outline-secondary" onClick={ShowNames} type="button">
                <MaterialSymbol icon="visibility" size={18} />Show
              </button>
              <button className="btn btn-outline-secondary" onClick={Transfair} type="button">
                <MaterialSymbol icon="auto_fix_high" size={18} />Transform
              </button>
              <button className="btn btn-primary" onClick={Load} type="button">
                <MaterialSymbol icon="cloud_upload" size={18} />Load changes
              </button>
            </>
          )
        )}
      />

      {Attendants.length > 0 && (
        <>
          <div className="workspace-progress">
            <span>Updated {updatedIndexes.length} of {Attendants.length}</span>
            <div className="progress" role="progressbar" aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" aria-label="City update progress">
              <div className="progress-bar" style={{ width: `${progress}%` }}>{progress}%</div>
            </div>
          </div>
          <DataTable>
            <thead>
              <tr>
                <th>Name</th>
                <th>Country</th>
                <th>City</th>
              </tr>
            </thead>
            <tbody>
              {Attendants.map((attendant, index) => {
                const needsReview = attendant.country !== 'Iraq' && CitiesInIraq.includes(attendant.city);
                return (
                  <tr key={attendant.id} className={updatedIndexes.includes(index) ? 'table-success' : ''}>
                    <td className={needsReview ? 'table-warning' : ''}>{attendant.first_name} {attendant.last_name}</td>
                    <td className={needsReview ? 'table-warning' : ''}>{attendant.country}</td>
                    <td className={needsReview ? 'table-warning' : ''}>{attendant.city}</td>
                  </tr>
                );
              })}
            </tbody>
          </DataTable>
        </>
      )}
    </>
  );
};

export default Cities;
